
import React from "react"
import { StaticImage } from "gatsby-plugin-image";

const LayoutHeader = ({
  children,Sobre //Le contenu encadré par le composant
}) => {


  return (
    <header className="div1 h-screen pb-2.5 z-40 overflow-hidden relative bg-fixed bg-center bg-cover noir-bckd -top-20">
      {children}
      {
        !Sobre ?
      <StaticImage
				className="absolute bottom-0 right-0 w-96 z-0"
				src="../../../static/imgs/n-light.svg"
				alt=""
			/>
      :''
      }
      <svg className='hidden md:block absolute top-4 left-2 diagonal-to-bottom-right'  viewBox="0 0 20 15" width={20} >
        <path className="orange-fill"  d="M12,0H3C2.9,0,2.8,0,2.7,0C2.6,0,2.6,0,2.5,0C1.8,0,1.3,0.3,0.8,0.8C0.3,1.3,0,1.8,0,2.5c0,0.1,0,0.1,0,0.2C0,2.8,0,2.9,0,3v9c0,1.6,1.1,3,2.5,3S5,13.6,5,12V5h7c1.6,0,3-1.1,3-2.5S13.6,0,12,0z" />
      </svg>
      <svg className='hidden md:block absolute bottom-2 left-2 diagonal-to-top-right'  viewBox="0 0 20 15" width={20}>
        <path className="orange-fill"  d="M2.5,3v9c0,0.1,0,0.2,0,0.3c0,0.1,0,0.1,0,0.2c0,0.7,0.3,1.2,0.8,1.7S4.3,15,5,15c0.1,0,0.1,0,0.2,0 c0.1,0,0.2,0,0.3,0h9c1.6,0,3-1.1,3-2.5s-1.4-2.5-3-2.5h-7V3c0-1.6-1.1-3-2.5-3S2.5,1.4,2.5,3z" />
      </svg>
      <svg className='hidden md:block absolute bottom-2 right-2 diagonal-to-top-left' viewBox="0 0 20 15" width={20}>
        <path className="orange-fill"  d="M5.5,15h9c0.1,0,0.2,0,0.3,0c0.1,0,0.1,0,0.2,0c0.7,0,1.2-0.3,1.7-0.8s0.8-1,0.8-1.7c0-0.1,0-0.1,0-0.2 c0-0.1,0-0.2,0-0.3V3c0-1.6-1.1-3-2.5-3s-2.5,1.4-2.5,3v7h-7c-1.6,0-3,1.1-3,2.5S3.9,15,5.5,15z"/>
      </svg>
      <svg className='hidden md:block absolute top-4 right-2 diagonal-to-bottom-left' viewBox="0 0 20 15" width={20}>
        <path className="orange-fill"  d="M17.5,12V3c0-0.1,0-0.2,0-0.3c0-0.1,0-0.1,0-0.2c0-0.7-0.3-1.2-0.8-1.7C16.2,0.3,15.7,0,15,0 c-0.1,0-0.1,0-0.2,0c-0.1,0-0.2,0-0.3,0h-9c-1.6,0-3,1.1-3,2.5S3.9,5,5.5,5h7v7c0,1.6,1.1,3,2.5,3S17.5,13.6,17.5,12z" />
      </svg>
    </header>
  )
}
export default LayoutHeader
